/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TrustedUserSessionIssuerReference,
  TrustedUserSessionIssuerReference$inboundSchema,
} from "./trustedusersessionissuerreference.js";

/**
 * Authoritative impact summary for deleting a remote_session_issuer: its client, trusted user-session-issuer, and active identity-chaining binding references.
 */
export type OrganizationIssuerDeletePreflight = {
  /**
   * Number of non-deleted remote_session_clients registered with this issuer.
   */
  clientCount: number;
  /**
   * Active identity-chaining bindings that must be explicitly unlinked before deletion.
   */
  emaBindingCount: number;
  /**
   * Display names of MCP servers attached to this issuer's clients.
   */
  mcpServerNames: Array<string>;
  /**
   * Organization-owned user_session_issuers that trust this issuer and block deletion.
   */
  trustedUserSessionIssuers: Array<TrustedUserSessionIssuerReference>;
};

/** @internal */
export const OrganizationIssuerDeletePreflight$inboundSchema: z.ZodMiniType<
  OrganizationIssuerDeletePreflight,
  unknown
> = z.pipe(
  z.object({
    client_count: z.int(),
    ema_binding_count: z.int(),
    mcp_server_names: z.array(z.string()),
    trusted_user_session_issuers: z.array(
      TrustedUserSessionIssuerReference$inboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_count": "clientCount",
      "ema_binding_count": "emaBindingCount",
      "mcp_server_names": "mcpServerNames",
      "trusted_user_session_issuers": "trustedUserSessionIssuers",
    });
  }),
);

export function organizationIssuerDeletePreflightFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationIssuerDeletePreflight, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationIssuerDeletePreflight$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationIssuerDeletePreflight' from JSON`,
  );
}
